import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

import { QuickAccessSkeleton } from './components/quick-access/quick-access-skeleton.tsx'

/**
 * Pending placeholder for the Accueil screen — mirrors the real page frame, with `QuickAccessSkeleton` mirroring
 * the real tile grid.
 */
export function HomePageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={220} height={32} />
        </View.Header>
        <View.Body>
          <Section.Root>
            <Section.Header>
              <Section.Title>{translate('quick_access')}</Section.Title>
            </Section.Header>
            <Section.Body>
              <QuickAccessSkeleton />
            </Section.Body>
          </Section.Root>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
